module.exports = __webpack_public_path__ + "media/images/logo_dots-5a26a19b193fae31a9b2f362dbfff698.png";